<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <h1>system authorization</h1>
    </Content>
  </div>
</template>
<script>
export default {

}
</script>
